'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRedux = require('react-redux');

var _playlists = require('redux/modules/playlists');

var playlistsActions = _interopRequireWildcard(_playlists);

var _playlists2 = require('selectors/playlists');

var _reduxConnect = require('redux-connect');

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _asyncPromise = require('helpers/async-promise');

var _asyncPromise2 = _interopRequireDefault(_asyncPromise);

var _PlaylistsFilterButtons = require('./components/PlaylistsFilterButtons/PlaylistsFilterButtons');

var _PlaylistsFilterButtons2 = _interopRequireDefault(_PlaylistsFilterButtons);

var _PlaylistsToggleViewButton = require('./components/PlaylistsToggleViewButton/PlaylistsToggleViewButton');

var _PlaylistsToggleViewButton2 = _interopRequireDefault(_PlaylistsToggleViewButton);

var _PlaylistsSorter = require('./components/PlaylistsSorter/PlaylistsSorter');

var _PlaylistsSorter2 = _interopRequireDefault(_PlaylistsSorter);

var _PlaylistsSearchBar = require('./components/PlaylistsSearchBar/PlaylistsSearchBar');

var _PlaylistsSearchBar2 = _interopRequireDefault(_PlaylistsSearchBar);

var _AlbumsItemsGroups = require('components/AlbumsItems/AlbumsItemsGroups/AlbumsItemsGroups');

var _AlbumsItemsGroups2 = _interopRequireDefault(_AlbumsItemsGroups);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./Playlists.scss');

var Playlists = (_dec = (0, _reduxConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch,
        projectType = _ref.params.projectType;

    dispatch(playlistsActions.setTypeFilter(projectType));
    return (0, _asyncPromise2.default)(dispatch(playlistsActions.loadPlaylists(projectType)).promise);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    albums: (0, _playlists2.getSortedAlbums)(state),
    playlistsLoading: state.playlists.playlistsLoading,
    showGroups: state.playlists.showGroups,
    tracks: (0, _playlists2.getPlaylistsTracks)(state)
  };
}), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Playlists, _Component);

  function Playlists() {
    (0, _classCallCheck3.default)(this, Playlists);
    return (0, _possibleConstructorReturn3.default)(this, (Playlists.__proto__ || (0, _getPrototypeOf2.default)(Playlists)).apply(this, arguments));
  }

  (0, _createClass3.default)(Playlists, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          playlistsLoading = _props.playlistsLoading,
          albums = _props.albums,
          showGroups = _props.showGroups,
          tracks = _props.tracks;
      var t = this.context.t;


      return _react2.default.createElement(
        'div',
        { className: (0, _bind2.default)(styles.playlists, 'container-fluid', 'page') },
        _react2.default.createElement(_reactHelmet2.default, { title: t('Playlists') }),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_PlaylistsToggleViewButton2.default, { className: 'pull-right' }),
          _react2.default.createElement(
            'h1',
            null,
            t('My Content')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.filters },
          _react2.default.createElement(_PlaylistsFilterButtons2.default, null),
          _react2.default.createElement(
            'div',
            { className: 'pull-left margin-vert-5' },
            _react2.default.createElement(_PlaylistsSorter2.default, null),
            _react2.default.createElement(_PlaylistsSearchBar2.default, null)
          )
        ),
        _react2.default.createElement(_AlbumsItemsGroups2.default, {
          albums: albums,
          tracks: tracks,
          showTitles: showGroups,
          loading: playlistsLoading
        })
      );
    }
  }]);
  return Playlists;
}(_react.Component), _class2.propTypes = {
  albums: _propTypes2.default.array,
  playlistsLoading: _propTypes2.default.bool,
  showGroups: _propTypes2.default.bool,
  tracks: _propTypes2.default.object
}, _class2.contextTypes = {
  t: _propTypes2.default.func
}, _temp)) || _class) || _class);
exports.default = Playlists;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Playlists/Playlists.js
// module id = 2181
// module chunks = 1